import {isNullOrUndefined} from "../../services/Validator";
import {useCallback, useEffect, useState} from "react";
import {isNumber} from "chart.js/helpers";
import {get_single_question} from "../../api/question";
import PreviewScreenError from "../../components/errors/previewScreen/PreviewScreenError";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {internalRoutes} from "../../constants/internalRoutes";
import {getLocalItemAsJsonFromKey, kTokenKey} from "../../services/LocalStorage";
import PreviewQuestionSideBar from "../../components/bars/previewScreens/PreviewQuestionSideBar";
import PreviewFlashQuestionContent from "../../components/others/previewScreens/PreviewFlashQuestionContent";
import SystemScreenLoader from "../../components/loaders/SystemScreenLoader";

export default function PreviewQuestionScreen() {
    // Used in PreviewScreen to handle single question
    // visualization, only accessible to admins

    // PROPERTIES
    // ---- Meta
    const location = useLocation()
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    // ---- Functional
    const [question, setQuestion] = useState(null)
    const [displayCorrection, setDisplayCorrection] = useState(false)
    const [device, setDevice] = useState("desktop")

    // HOOKS
    // ---- Memorizes a function, preventing it from being redefined on every render, unless its dependencies change.
    const getSingleQuestion = useCallback(() => {
        // Define
        const redirectToAuthenticationScreen = () => {
            navigate(`${internalRoutes.authentication}?redirect=${encodeURIComponent(location.pathname)}`)
        }

        // Defense
        // ---- Current screen URL (question) id parameter
        if (isNullOrUndefined(id) || !isNumber(id) || id < 0)
            return
        // ---- Get token from local storage
        const token = getLocalItemAsJsonFromKey(kTokenKey);
        if (!token) {
            redirectToAuthenticationScreen()
            return
        }

        // Perform
        // ---- Loader on and clear potential error
        setIsLoading(true)
        setError(null)
        // ---- Api call
        get_single_question(id, token)
            .then((res) => {
                setQuestion(res)
                setError(null)
            }).catch((err) => {
            setError('Error in fetching question')
            console.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [id, location.pathname, navigate])
    // ---- Triggered at rendering : get single Question only in dev and staging env
    useEffect(() => {
        getSingleQuestion()
    }, [getSingleQuestion])

    // BUILD
    if (error)
        return <PreviewScreenError goBackToHome={() => {navigate(internalRoutes.home)}}
                                   retryFetching={getSingleQuestion} />
    if (isLoading)
        return <SystemScreenLoader />
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 overflow-auto w-full h-[100svh] flex justify-start items-center"}>
            <PreviewQuestionSideBar goBackToHome={() => navigate(internalRoutes.home)}
                                    displayCorrection={displayCorrection}
                                    toggleView={toggleView} question={question} device={device} setDevice={setDevice} />
            <PreviewFlashQuestionContent question={question}
                                         device={device}
                                         displayCorrection={displayCorrection}
                                         refreshQuestion={getSingleQuestion} />
        </div>
    );

    // METHODS
    // ---- Toggle view to display
    function toggleView() {
        setDisplayCorrection(!displayCorrection)
    }
}